import React from 'react';
import moment from 'moment';
import { ToBillArguments, ToBillEvent } from '../../../models/Factura';
import { ProfileQL } from '../../../models/Profile';
import Input from '../../Forms/Input';
import Select from '../../Forms/Select';
import { conceptoToTotales } from '../../../utils/calculate.conceptos';
import { GLOBAL_MES, REGIMEN_OPT } from '../../Facturar/constants/factura.options';
import PreviewConceptos from './Preview.conceptos';
import PreviewTotales from './Preview.totales';
import PreviewPagos from './Preview.pagos';

interface PreviewMainBillProps {
    currentUser: ProfileQL;
    toBillArgument: ToBillArguments<ToBillEvent>;
    toPaymentEvents: ToBillEvent[];
    // Emitters
    onChangeName: (name: string) => void;
    onChangeEmail: (email: string) => void;
    onChangeZip: (zip: string) => void;
    onChangeRegimen: (regimen: string) => void;
    onChangePayment: (eventIndex: number) => (value: number) => void;
    onChangePaymentDate: (eventIndex: number) => (date: Date) => void;
}

function PreviewMainBill({
    currentUser,
    toBillArgument,
    toPaymentEvents,
    onChangeName,
    onChangeEmail,
    onChangeZip,
    onChangeRegimen,
    onChangePayment,
    onChangePaymentDate }: PreviewMainBillProps) {

    if (!toBillArgument) {
        return null;
    }
    const totales = conceptoToTotales(toBillArgument.MasterCFDI.conceptos);
    console.log('TOTALES PREVIEW: ', totales);

    const mesGlobalLabel = toBillArgument.MasterCFDI?.global?.mes ? GLOBAL_MES.find(gM => gM.value === toBillArgument.MasterCFDI.global.mes).label : '';
    const anoGlobalLabel = toBillArgument.MasterCFDI?.global?.ano ? toBillArgument.MasterCFDI?.global?.ano : '';

    return (
        <div>
            <h4>{toBillArgument.multipayType === 1 ? 'Factura de adelanto' : 'Factura principal'}</h4>
            <div className="card table">
                <div className="cardBody">
                    {
                        toBillArgument.MasterCFDI.fecha ?
                            <div className="row four xlg-three md-two sm-one">
                                <Input value={moment(toBillArgument.MasterCFDI.fecha).format('YYYY-MM-DD')} label="Fecha" type="text" disabled={true} />
                            </div>
                            : null
                    }
                    <div className="row four xlg-three md-two sm-one">
                        <Input value={currentUser.fiscalpopProfile.nombre} label="Cliente emisor" type="text" disabled={true} />
                        <div className='row md-hidden' />
                        <div className='row xlg-hidden' />
                        {
                            toBillArgument.MasterCFDI.global ?
                                <div className='row three gap-compressed'>
                                    <Input value={toBillArgument.MasterCFDI.global.periodo} label="Periodo" type="text" disabled={true} />
                                    <Input value={`${mesGlobalLabel}`} label="Mes" type="text" disabled={true} />
                                    <Input value={`${anoGlobalLabel}`} label="Año" type="text" disabled={true} />
                                </div>
                                : null
                        }
                    </div>
                    <div className="row emisor">
                        <Input value={toBillArgument.MasterCFDI.receptor.nombre} label="Receptor" type="text" disabled={!!toBillArgument.MasterCFDI.global} onChange={onChangeName} />
                        <Input value={toBillArgument.MasterCFDI.receptor.rfc} label="RFC Receptor" type="text" disabled={true} />
                        <Input value={toBillArgument.MasterCFDI.receptor.email} label="Email" type="text" disabled={false} onChange={onChangeEmail} />
                    </div>
                    <div className="row emisor">
                        <div className="row two">

                            <Select value={toBillArgument.MasterCFDI.receptor.regimen} label="Regimen Receptor" onChange={onChangeRegimen} placeholder="Régimen fiscal del receptor" options={REGIMEN_OPT} disabled={true} />
                            <Input value={toBillArgument.MasterCFDI.receptor.zip} label="Codigo Postal" type="text" disabled={!!toBillArgument.MasterCFDI.global} onChange={onChangeZip} />
                        </div>
                        <div className="row sm-two">
                            <Input value={toBillArgument.MasterCFDI.receptor.usoCFDI} label="Uso CFDI" type="text" disabled={true} />
                        </div>
                        <div className="row two">
                            <Input value={toBillArgument.MasterCFDI.formaPago} label="Forma de pago" type="text" disabled={true} />
                            <Input value={toBillArgument.MasterCFDI.metodoPago} label="Metodo de pago" type="text" disabled={true} />
                        </div>

                    </div>
                    <PreviewConceptos conceptos={toBillArgument.MasterCFDI.conceptos} showNoIdentificacion={true} />
                    <PreviewTotales totales={totales} showDescuento={true} />
                    <PreviewPagos
                        toBillArgument={toBillArgument}
                        toPaymentEvents={toPaymentEvents}
                        onChangePayment={onChangePayment}
                        onChangePaymentDate={onChangePaymentDate}
                    />
                </div>
            </div>
        </div>
    )
}

export default PreviewMainBill;
